import { UnitQueueRowData } from '../../../socket/stream-types';
import { MinutesCell } from '../../../queues/components/cells/common/minutes-cell';
import { observer } from 'mobx-react-lite';

export const TimeSinceUnitLocationUpdatedCell = observer(function TimeSinceUnitLocationUpdatedCell({
    data,
}: {
    data: UnitQueueRowData;
}): React.ReactElement {
    return <MinutesCell date={data.unitLocationInfoCreatedDateTime} />;
});
